<template>
  {{ i18n(deliveredTranslation, { date: new Date(date) }) }}
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import productReturnTranslations from './ProductReturn.translations'

const i18n = useI18n()

const props = defineProps<{
  isOneWay: boolean
  isHandledByBackrepair: boolean
  date: string
}>()

const deliveredTranslation = computed(() => {
  if (props.isOneWay) {
    if (props.isHandledByBackrepair) {
      return productReturnTranslations.factoryDeliveryDate
    }

    return productReturnTranslations.delivered
  }

  return productReturnTranslations.customerDeliveryDate
})
</script>
